import { PermissionsResponse, PermissionsResponseDTO } from "auth"
import { Mapper } from "lib/api"

// first param is the DTO, second param is the class
export class PermissionsMapper extends Mapper<PermissionsResponseDTO, PermissionsResponse> {
	constructor() {
		super(PermissionsResponse) // Pass the target class constructor
	}
}

export function New(): PermissionsMapper {
	return new PermissionsMapper()
}
